module.exports = __webpack_public_path__ + "img/checked-icon.17cd7bd7.svg";